/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, memo, type Ref } from 'react';

import { jsx } from '@compiled/react';

import type { TabProps } from '@atlassian/navigation-kit-common/src/types';

import DropdownTriggerTab from './dropdown-trigger-tab';
import LinkTab from './link-tab';

const OuterTab = memo(
	forwardRef((props: TabProps, outerRef: Ref<HTMLElement>) => {
		if (props.type === 'dropdown-trigger') {
			return <DropdownTriggerTab {...props} ref={outerRef} />;
		}

		if (props.type === 'anchor' || props.type === 'router-link' || props.type === undefined) {
			return <LinkTab {...props} ref={outerRef} />;
		}
		return null;
	}),
);
export default OuterTab;
